import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { InternationalHotelsRepository } from '@core/services/repositories/international-hotels.repository';
import { InternationalHotelsService } from './international-hotels.service';

export const internationalHotelsResolver: ResolveFn<any> = () => {
  const intnhService = inject(InternationalHotelsService);
  const platformId = inject(PLATFORM_ID);
  if (isPlatformServer(platformId)) {
    return intnhService.getHotels(); // ✅ فقط در SSR
  } else {
    intnhService.getHotels(); // ✅ در CSR فقط اجرا
    return;
  }
}
  